var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { to } from "@lib/utils";
import { User } from "@models/user";
import { get, post } from "./api";
import { EVM_NETWORKS } from "@models/network";
import { transformEmailAddr } from "utils/misc";
import { JobName, JobStatus } from "@models/job";
export const mintNFT = (recipient, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    console.log("mintNFT:::", transaction);
    try {
        if (!transaction.contactInfos || transaction.contactInfos.length === 0)
            throw "transactions's contactInfos not found";
        const { res: ticket } = yield to(get(`/tickets/${transaction.ticketId}`));
        if (!ticket)
            throw "ticket not found";
        const contractId = ticket.contractId;
        console.log("contractId:::", contractId);
        if (!contractId)
            throw "ticket's contractId not found";
        const { res: contract } = yield to(get(`/contracts/${contractId}`));
        if (!contract)
            throw `contract of ${contractId} not found`;
        console.log("contract:::", contract);
        let template = transaction.templateId;
        console.log("template:::", template);
        const contactInfos = transaction.contactInfos || [];
        let jobIds = [];
        for (const contactInfo of contactInfos) {
            //console.log("mintNFT:::contactInfo", contactInfo);
            if (ticket.uniqueNFT !== 1) {
                const { res: transfers } = yield to(get(`/nfts/transfers/${contract.network}/${contract.address}`));
                console.log("transfer:::", transfers);
                template = `${template}-${transfers.length % ticket.uniqueNFT}`;
            }
            console.log("template:::", template);
            const { err, res: user } = yield to(get(`/users/user/${contactInfo.emailAddress}`));
            if (err)
                console.error("mintNFT:::get user err", err);
            let jobId = "";
            if (user) {
                const user_ = new User(user);
                //console.log("mintNFT:::user", user_);
                //
                console.log("mintNFT:::user", user_);
                const walletAddress = (_a = user_.wallets.find((w) => EVM_NETWORKS.includes(w.network))) === null || _a === void 0 ? void 0 : _a.address;
                console.log("mintNFT:::user wallet", walletAddress);
                console.log("recipient:::", recipient);
                let _recipient = recipient || walletAddress;
                if (!_recipient) {
                    console.log("mintNFT:::user wallet not found");
                    continue;
                }
                console.log("mintNFT:::_recipient", _recipient);
                const { err, res: job } = yield to(post(`/nfts/${contractId}/airdrop`, {
                    recipient: _recipient,
                    template,
                }));
                if (err || !job)
                    console.error("mintNFT:::airdrop err", err);
                //console.log("mintNFT:::airdrop data", job);
                jobId = job.jobId || "";
            }
            else {
                const { err, res: job } = yield to(post(`/jobs`, {
                    name: JobName.AIRDROP_NFT,
                    status: JobStatus.PENDING,
                    data: {
                        identifier: transformEmailAddr(contactInfo.emailAddress),
                        metadataTemplateId: template,
                        contractId,
                    },
                }));
                if (err || !job)
                    return console.error("mintNFT:::err", err);
                //console.log("mintNFT:::post job data", job);
                jobId = job.jobId || "";
            }
            jobIds.push(jobId);
        }
        //console.log("mintNFT:::jobIds", jobIds);
        const { err, res: data } = yield to(post(`/transactions/mark/${transaction.id}`, {
            jobIds,
        }));
        if (err || !data)
            return console.error("mintNFT:::err", err);
        //console.log("mintNFT:::data", data);
        return true;
    }
    catch (err) {
        console.error(err);
        return false;
    }
});
